<template>
	<div class="disc-profile-layout">
		<header class="disc-profile-layout__header">
			<div v-if="showWheel" class="disc-profile-layout__disc-wheel">
				<div>
					<DISCWheel
						:activeWorkStyles="[ moniker ]"
					/>
				</div>
			</div>
			<div v-if="showMoniker || showDescriptors || showDescription" class="disc-profile-layout__summary">
				<div v-if="showMoniker || showDescriptors" class="disc-profile-layout__descriptors">
					<div v-if="showMoniker" :class="chipClasses">{{ moniker }}</div>
					<AssessmentDescriptors v-if="showDescriptors" :assessment="assessment" />
				</div>
				<p v-if="showDescription" class="disc-profile-layout__description">{{ description }}</p>
			</div>
		</header>
		<main class="disc-profile-layout__body">
			<AssessmentProfileLayoutHeading
				class="disc-profile-layout__section-heading"
				:assessment="assessment"
				:border="true"
			>
				<slot name="primaryHeading" />
			</AssessmentProfileLayoutHeading>
			<div class="disc-profile-layout__section-row">
				<slot name="primaryCharacteristics" />
			</div>

			<AssessmentProfileLayoutHeading
				class="disc-profile-layout__section-heading"
				:assessment="assessment"
				:border="true"
			>
				<slot name="secondaryHeading" />
			</AssessmentProfileLayoutHeading>
			<div class="disc-profile-layout__section-row">
				<slot name="secondaryCharacteristics" />
			</div>
		</main>
	</div>
</template>

<script>
import AssessmentDescriptors from "./AssessmentDescriptors";
import DISCWheel from "./DISCWheel";
import AssessmentProfileLayoutHeading from "./AssessmentProfileLayoutHeading";

export default {
	name: "AssessmentProfileLayout",

	components: {
		DISCWheel,
		AssessmentDescriptors,
		AssessmentProfileLayoutHeading,
	},

	props: {
		user: {
			type: Object,
			required: true,
		},
		showWheel: {
			type: Boolean,
			default: true,
		},
		showMoniker: {
			type: Boolean,
			default: true,
		},
		showDescriptors: {
			type: Boolean,
			default: true,
		},
		showDescription: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		chipClasses() {
			const { highType, } = this;
			return {
				"text-ms2": true,
				"discTextLabel__hightype-chip": true,
				[ `discTextLabel__${ highType }-hightype-chip` ]: true,
			};
		},
		assessment() {
			return this.user?.assessments?.DISC;
		},
		moniker() {
			return this.assessment.moniker;
		},
		highType() {
			return this.assessment.moniker[ 0 ].toUpperCase();
		},
		description() {
			return this.assessment?.teamingContent?.description || "";
		},
	},
};
</script>

<style lang="scss" scoped>
.disc-profile-layout {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.disc-profile-layout__header {
	display: flex;
	flex-direction: column-reverse;
	gap: 1rem;

	@include for-size-and-larger('sm') {
		flex-direction: row;
	}
}

.disc-profile-layout__summary {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.disc-profile-layout__body {
	display: flex;
	flex-direction: column;
	gap: 2rem;

	width: 100%;
}

.disc-profile-layout__section-heading {
	padding-bottom: 1rem;
}

.disc-profile-layout__section-row {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	flex-wrap: wrap;
	gap: 2rem;

	width: 100%;

	@include for-size-and-larger('sm') {
		flex-direction: row;
		gap: 2rem;
	}
}

.disc-profile-layout__descriptors {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 1rem;
}

.disc-profile-layout__description {
	@include font-and-line-for(0);
	text-align: left;
}

.disc-profile-layout__disc-wheel {
	display: flex;
	flex-direction: row;
	justify-content: center;

	> div {
		max-width: 16.25rem;
		min-width: 12.5rem;
	}
}
</style>

<style lang="scss">
// this style should not be scoped as it applies
// to children in slots
.disc-profile-layout__section-row {
	@include for-size-and-larger('sm') {
		> * {
			flex-basis: 45%;
		}
	}
}
</style>
